import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseEmailTemplatesComponent, TemplateParameters } from '../../base-email-templates-landing-page.component';
import { AssetsUserDetailsService, TransferAssetService } from 'assets-service';


@Component({
  selector: 'transfer-reminder-email-templates',
  templateUrl: './transfer-reminder-email-templates.component.html',
  styleUrls: ['./transfer-reminder-email-templates.component.scss']
})
export class TransferReminderEmailTemplatesComponent extends BaseEmailTemplatesComponent {

  constructor(private assetsUserDetailsService: AssetsUserDetailsService,
    private transferAssetServie: TransferAssetService) {
    super();
  }

  protected getExampleTemplateParameters(backgroundServiceCall?: boolean): Observable<TemplateParameters> {
    return this.transferAssetServie.exampleTransferReminderEmailTemplateParameters(backgroundServiceCall);
  }


}
